import { render, staticRenderFns } from "./sendpulse_bot_tab.vue?vue&type=template&id=470a76b0&scoped=true&"
import script from "./sendpulse_bot_tab.vue?vue&type=script&lang=js&"
export * from "./sendpulse_bot_tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470a76b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('470a76b0')) {
      api.createRecord('470a76b0', component.options)
    } else {
      api.reload('470a76b0', component.options)
    }
    module.hot.accept("./sendpulse_bot_tab.vue?vue&type=template&id=470a76b0&scoped=true&", function () {
      api.rerender('470a76b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/sendpulse/location/tabs/sendpulse_bot_tab.vue"
export default component.exports